var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',{attrs:{"outlined":"","block":"","flat":false,"to":_vm.addEventUrl}},[_c('v-icon',{staticClass:"mr-1",attrs:{"icon":"today"}}),_vm._v(" "+_vm._s(_vm.$t("components.pageActions.schedule.addToCalendar.addCalendar"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }